import { CVCompetenceGroups } from "./cvcompetencegroups.component";
import { CVCompetenceGroup } from "./cvcompetencegroup.component";
import { EditCVCompetenceGroup } from "./cvcompetencegroup.edit.component";
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIRouterModule } from "@uirouter/angular";
import { cvCompetenceGroupsState, cvCompetenceGroupState, newCvCompetenceGroupState, editCvCompetenceGroupState } from "./cvcompetencegroups.states";
import { AllMaterialModule } from "../../all-material.components";
import { FlexLayoutModule } from "@angular/flex-layout";

import SharedModule from "../../shared/shared.module";
import { CoreModule } from "../../core/core.module";

let STATES = [cvCompetenceGroupsState, cvCompetenceGroupState, newCvCompetenceGroupState, editCvCompetenceGroupState];

import { ConfirmDialog } from "../../shared/confirm-dialog.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        AllMaterialModule,
        SharedModule,
        CoreModule,
        FlexLayoutModule,
        UIRouterModule.forChild({ states: STATES })
    ],
    declarations: [CVCompetenceGroups, CVCompetenceGroup, EditCVCompetenceGroup],
    entryComponents: [ConfirmDialog]
})
export default class CVCompetenceGroupsModule {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/cvcompetencegroups/cvcompetencegroups.module.ts